import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${p => p.$align === 'center' ? 'center' : 'flex-start'};
  gap: 12px;
  text-align: ${p => p.$align === 'center' ? 'center' : 'left'};
`;

const Eyebrow = styled.span`
  font-family: ${p => p.theme.fonts.mono};
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${p => p.theme.colors.starGold};
  opacity: 0.85;
`;

const H = styled.h1`
  font-family: ${p => p.theme.fonts.display};
  font-weight: 500;
  font-style: ${p => p.$italic ? 'italic' : 'normal'};
  font-size: clamp(1.8rem, ${p => p.$size === 'xl' ? '4.2vw' : '3.4vw'}, ${p => p.$size === 'xl' ? '3.4rem' : '2.6rem'});
  line-height: 1.35;
  letter-spacing: 0.01em;
  color: ${p => p.theme.colors.text};
  margin: 0;

  /* 日本語タイトルの改行制御:
   * - 文節 (単語) の途中で切らない (keep-all)
   * - max-width を広めに取り、PC では横幅を使う
   * - モバイルではコンテナ幅に追従して自然に折り返す
   */
  width: 100%;
  max-width: 100%;
  word-break: keep-all;
  overflow-wrap: normal;
  line-break: strict;
`;

const Sub = styled.p`
  font-family: ${p => p.theme.fonts.body};
  font-size: 0.95rem;
  line-height: 1.85;
  color: ${p => p.theme.colors.textSecondary};
  margin: 0;
  max-width: 64ch;
  word-break: keep-all;
  overflow-wrap: normal;
  line-break: strict;
`;

/**
 * DisplayHeading — ページ・セクションのヒーロー見出し
 *
 * <DisplayHeading
 *   eyebrow="STRUCT CODE"
 *   title="夜に置いた25の問いが、ひとつのかたちに戻ってくる"
 *   subtitle="..."
 *   align="center"
 *   italic
 * />
 */
const DisplayHeading = ({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  italic = false,
  size = 'md',
  as = 'h1',
}) => (
  <Wrap $align={align}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <H as={as} $italic={italic} $size={size}>{title}</H>
    {subtitle && <Sub>{subtitle}</Sub>}
  </Wrap>
);

export default DisplayHeading;
